import React from 'react';
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles(
    (theme) => {
        return {

            overlay: {
                position: 'absolute',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255,255,255,0.5)',
                zIndex:3
            }
        }
    }
)


export default function TableActions(props){

    const classes = useStyles();

    const {actions,item} = props;

    const [isDoingAction,setIsDoingAction] = React.useState();

    async function doAction(item,action){

        setIsDoingAction(true);

        const {axiosInstance,onSuccess,onError} = action.getHttpAction(item);

        try {

            const response = await axiosInstance();

            if(onSuccess)
                onSuccess(item,response.data);

        } catch (e) {

            if(onError)
                onError(item);

        } finally {

            setIsDoingAction(false);

        }



    }

    return (
        <div className={'position-relative'}>

            {
                actions.map(
                    (action,index) => {

                        if(action.shouldDisplay && !action.shouldDisplay(item))
                            return null;
                        
                        return (
                            <div key={index} className={'d-inline-block mr-1 mb-1'} onClick={()=>{
                                if(action.onClick)
                                    action.onClick(item || {},actions);

                                else if(action.getHttpAction)
                                    doAction(item,action)

                            }}>

                                {
                                    (action.icon || action.text) && (
                                        <button
                                            disabled={isDoingAction}
                                            className={clsx([
                                            'btn btn-light-primary font-weight-bold',
                                            {['btn-icon']: action.icon && !action.text}
                                        ])}>

                                            {action.icon && (
                                                <i className={action.icon}></i>
                                            )}

                                            {action.text}


                                        </button>
                                    )
                                }

                                {
                                    action.render && (
                                        <div className={'b-inline-block'}>
                                            {action.render(item,isDoingAction)}
                                        </div>
                                    )
                                }

                            </div>
                        )
                    }
                )
            }


            {
                isDoingAction && (
                    <div className={classes.overlay}>
                        <CircularProgress size={16} disableShrink />
                    </div>
                )
            }

        </div>
    );
}